import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './shared/components/ui/toast/toast.component';
import { OfflineComponent } from './offline/offline.component';
import { NetworkStatusService } from './core/services/network-status.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastComponent, OfflineComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (network.isOnline()) {
      <router-outlet /><app-toast />
    } @else {
      <app-offline />
    }
  `
})
export class App {
  protected readonly network = inject(NetworkStatusService);
}
